import { GitCompare } from "lucide-react";
import { cn } from "@/lib/utils";
import type { WorkspaceTab } from "./use-workspace-search-params";

interface WorkspaceTabsStripProps {
  activeTab: WorkspaceTab;
  onTabChange: (tab: WorkspaceTab) => void;
  findingsCount: number;
  stepsCount: number;
}

export function WorkspaceTabsStrip({
  activeTab,
  onTabChange,
  findingsCount,
  stepsCount,
}: WorkspaceTabsStripProps) {
  return (
    <nav
      aria-label="Walkthrough detail views"
      className="border-b border-border"
    >
      <ul className="flex gap-6 overflow-x-auto no-scrollbar">
        <li>
          <button
            type="button"
            onClick={() => onTabChange("findings")}
            aria-current={activeTab === "findings" ? "page" : undefined}
            className={cn(
              "-mb-px inline-flex h-9 items-center gap-1.5 border-b-2 text-sm font-medium whitespace-nowrap shrink-0 transition-colors cursor-pointer",
              activeTab === "findings"
                ? "border-foreground text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            <span>Findings</span>
            <span className="tabular-nums text-xs text-muted-foreground">
              {findingsCount}
            </span>
          </button>
        </li>

        <li>
          <button
            type="button"
            onClick={() => onTabChange("trace")}
            aria-current={activeTab === "trace" ? "page" : undefined}
            className={cn(
              "-mb-px inline-flex h-9 items-center gap-1.5 border-b-2 text-sm font-medium whitespace-nowrap shrink-0 transition-colors cursor-pointer",
              activeTab === "trace"
                ? "border-foreground text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            <span>Execution trace</span>
            <span className="tabular-nums text-xs text-muted-foreground">
              {stepsCount}
            </span>
          </button>
        </li>

        <li>
          <button
            type="button"
            onClick={() => onTabChange("compare")}
            aria-current={activeTab === "compare" ? "page" : undefined}
            className={cn(
              "-mb-px inline-flex h-9 items-center gap-1.5 border-b-2 text-sm font-medium whitespace-nowrap shrink-0 transition-colors cursor-pointer",
              activeTab === "compare"
                ? "border-foreground text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            <GitCompare className="size-3.5" aria-hidden="true" />
            <span>Compare runs</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
